<template>
  <v-container>
    <landing-create
      :content="createQuestionContent"
    >
    </landing-create>
    <specimen-additional-info-form
      v-if="specimenAdditionalInfo"
      :isLoading="isLoading"
      :specimenAdditionalInfo="specimenAdditionalInfo"
      :onSubmit="onSubmit"
    >
    </specimen-additional-info-form>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import SpecimenAdditionalInfoForm from './SpecimenAdditionalInfoForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { biobankRegistry } = services;
const { specimenAdditionalInfoService } = biobankRegistry;

export default {
  name: 'SpecimenAdditionalInfoUpdate',
  components: {
    SpecimenAdditionalInfoForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    createQuestionContent: {
      pageTitle: 'Update Specimen Info',
      enableBackButton: true,
    },
    specimenAdditionalInfo: null,
  }),
  async created() {
    const { id } = this.$route.params;
    const specimenAdditionalInfo = await specimenAdditionalInfoService.getOne({ id });
    this.specimenAdditionalInfo = specimenAdditionalInfo;
  },
  methods: {
    async onSubmit(data) {
      this.isLoading = true;
      try {
        await specimenAdditionalInfoService.update({ specimenAdditionalInfo: data });
        this.$snackbar.showOk({ text: 'Successfully updated Specimen Info!' });
        this.$router.push({ name: 'specimenAdditionalInfo.list' });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
